import {useEffect, useState} from "react";
import {NavSnipes} from "../../NavSnipes";
import styled from "styled-components";

const Container = styled.div`
    color: white;
    font-family: 'Inter', sans-serif;
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
    
    user-select: none;
    
    h2 {
        text-transform: uppercase;
        color: #d2a83a;
        font-size: 32pt;
    }

    table {
        margin: 0 20px;
        width: calc(100% - 40px);
        border-collapse: collapse;
        text-align: right;
        
        font-size: 11pt;
        
        th, td {
            margin: 0;
        }
        
        th:first-child, th:nth-child(2), td:first-child, td:nth-child(2) {
            text-align: left;
        }
        
        td:first-child {
            font-size: 12pt;
            font-weight: 500;
            width: 30px;
        }

        thead th {
            color: #d2a83a;
            border-bottom: solid 1px #9e7f2d;
            font-size: 12pt;
            font-weight: 400;
            cursor: pointer;
            padding-bottom: 10px;
        }
        
        tbody td {
            font-weight: 300;
            padding-top: 5px;
            vertical-align: middle;

            &:nth-child(2) {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 15px;
                
                span {
                    vertical-align: middle;
                    display: inline-block;
                    width: 32px;
                    height: 32px;
                    background-position: center;
                    background-size: cover;
                    background-color: #777;
                    border-radius: 50%;
                }
                
                p {
                    padding: 0;
                    margin: 0;
                }
            }
        }
        
        tbody tr:first-child td {
            padding-top: 10px;
        }
    }

    @media screen and (min-width: 800px) {
        table {
            td {
                font-size: 14pt;
            }
        }
    }
`;

export default function Leaderboard() {
    const [leaderboard, setLeaderboard] = useState([]);
    const [order, setOrder] = useState('-k');

    useEffect(() => {
        NavSnipes.getLeaderboard(order, 100).then(setLeaderboard);
    }, [setLeaderboard, order]);

    return (
        <Container>
            <h2>
                Leaderboard
            </h2>
            <table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th onClick={() => setOrder(order === '-k' ? 'k' : '-k')}>
                            Kills
                            <span style={{fontFamily: '"Times New Roman", serif'}}>
                                &nbsp;{order === '-k' ? '†' : (order === 'k' ? '⸸' : ' ')}
                            </span>
                        </th>
                        <th onClick={() => setOrder(order === '-d' ? 'd' : '-d')}>
                            Deaths
                            <span style={{fontFamily: '"Times New Roman", serif'}}>
                                &nbsp;{order === '-d' ? '†' : (order === 'd' ? '⸸' : ' ')}
                            </span>
                        </th>
                        <th onClick={() => setOrder(order === '-kd' ? 'kd' : '-kd')}>
                            K/D
                            <span style={{fontFamily: '"Times New Roman", serif'}}>
                                &nbsp;{order === '-kd' ? '†' : (order === 'kd' ? '⸸' : ' ')}
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {leaderboard.map((entry, index) => (
                        <tr key={entry.ID}>
                            <td>{index + 1}</td>
                            <td><span style={{backgroundImage: `url("${entry.AvatarURL}")`}}/><p>{entry.Name}</p></td>
                            <td>{entry.Kills}</td>
                            <td>{entry.Deaths}</td>
                            <td>{Math.round(entry.KDR*10**3)/10**3}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Container>
    )
}